/**
 * Utility functions for navigation with query param preservation
 * Follows Single Responsibility Principle - handles navigation concerns
 */

const PATH_TO_LIVE = '/pathToLive';
const RETURN_TO_PATH_TO_LIVE_SEARCH_KEY = 'returnToPathToLiveSearch';

/**
 * Navigates to merchant details page with query params preserved
 * @param {Object} history - React Router history object
 * @param {string|number} onboardingId - Onboarding ID for the merchant details page
 * @param {boolean} newTab - If true, opens in new tab with query params in URL
 */
export function navigateToMerchantDetails(history, onboardingId, newTab = false) {
    const pathname = `/merchantdetails/${onboardingId}`;

    if (newTab) {
        // If opening in new tab, include query params in URL
        const currentSearch = history.location.search;
        window.open(`${pathname}${currentSearch}`);
    } else {
        navigateWithQueryParamsPreserved(history, pathname);
    }
}

/**
 * Saves current query params in location state for later restoration
 * @param {Object} history - React Router history object
 * @param {string} pathname - Target pathname
 */
export function navigateWithQueryParamsPreserved(history, pathname) {
    const currentSearch = history.location.search;
    history.push({
        pathname,
        state: { [RETURN_TO_PATH_TO_LIVE_SEARCH_KEY]: currentSearch }
    });
}

/**
 * Restores query params when navigating back to pathToLive
 * @param {Object} history - React Router history object
 * @param {string} targetUrl - Target URL to navigate to
 * @returns {string} URL with restored query params if applicable
 */
export function restoreQueryParamsIfNeeded(history, targetUrl) {
    if (targetUrl === PATH_TO_LIVE && history.location.state && history.location.state[RETURN_TO_PATH_TO_LIVE_SEARCH_KEY]) {
        return `${targetUrl}${history.location.state[RETURN_TO_PATH_TO_LIVE_SEARCH_KEY]}`;
    }

    return targetUrl;
}

